import { render, staticRenderFns } from "./MaterialUploadPresentation.vue?vue&type=template&id=4d5bd907&scoped=true&"
import script from "./MaterialUploadPresentation.vue?vue&type=script&lang=js&"
export * from "./MaterialUploadPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5bd907",
  null
  
)

export default component.exports